module.exports = __webpack_public_path__ + "static/media/power_snatch-01.75367f61.png";